import { CardActionArea, makeStyles, Typography, Box } from "@material-ui/core";
import React from "react";
import Card from "react-bootstrap/Card";
import { FiUser, FiClock, FiBook, FiArrowRight } from "react-icons/fi";

const CardCustom = (props) => {
  const classes = useStyles();
  const {
    title = "Titulo por defecto",
    details = "Descripción por defecto",
    estado = 234,
    deadline,
    periodName,
    modalidad,
    onClick = () => {
      return;
    },
  } = props;

  const formatDate = (dateStr) => {
    if (!dateStr) return null;
    const date = new Date(dateStr.replace(" ", "T"));
    let day = date.getDate() < 10 ? `0${date.getDate()}` : date.getDate();
    let month =
      date.getMonth() + 1 < 10
        ? `0${date.getMonth() + 1}`
        : date.getMonth() + 1;
    let year = date.getFullYear();
    let hours = date.getHours() < 10 ? `0${date.getHours()}` : date.getHours();
    let minutes =
      date.getMinutes() < 10 ? `0${date.getMinutes()}` : date.getMinutes();
    return `${day}/${month}/${year} ${hours}:${minutes}`;
  };

  const Status = ({ estado }) => {
    let status = "";
    let backgroundColor = "";
    let color = "#FFFFFF";
    let icon = <FiArrowRight size={18} />;

    switch (estado) {
      case 322: // En Curso
        status = "Continuar Evaluación";
        backgroundColor = "#f59e0b"; // Ambar
        break;
      case 323: // Finalizado
        status = "Evaluación Finalizada";
        backgroundColor = "#10b981"; // Esmeralda
        break;
      case 999: // Expirado
        status = "Tiempo Agotado";
        backgroundColor = "#64748b"; // Slate
        break;
      default: // Sin Iniciar
        status = "Iniciar Evaluación";
        backgroundColor = "#9d2d39"; // Rojo CUC
        break;
    }

    return (
      <Box 
        className={classes.statusBtn}
        style={{ backgroundColor }}
      >
        <Typography variant="button" style={{ fontWeight: 800, color }}>
          {status}
        </Typography>
        {icon}
      </Box>
    );
  };

  return (
    <CardActionArea className={classes.container} onClick={onClick}>
      <Card className={classes.bootstrapCard}>
        <Card.Body className={classes.cardBody}>
          <Box className={classes.headerRow}>
            {modalidad && (
              <Box className={classes.tag} style={{
                backgroundColor: modalidad.toUpperCase().includes("POST") ? "rgba(123, 31, 162, 0.1)" : "rgba(25, 118, 210, 0.1)",
                color: modalidad.toUpperCase().includes("POST") ? "#7b1fa2" : "#1976d2",
              }}>
                {modalidad}
              </Box>
            )}
            {periodName && (
              <Typography className={classes.periodLabel}>
                {periodName}
              </Typography>
            )}
          </Box>

          <Box mt={1}>
            <Box display="flex" alignItems="center" gridGap={8} mb={0.5}>
              <FiBook size={16} color="#9d2d39" />
              <Typography className={classes.titleText}>
                {title}
              </Typography>
            </Box>
            
            <Box display="flex" alignItems="center" gridGap={8} mb={1.5}>
              <FiUser size={16} color="#64748b" />
              <Typography className={classes.teacherText}>
                {details.replace("Profesor: ", "")}
              </Typography>
            </Box>
          </Box>

          <Box display="flex" flexDirection="column" gridGap={4} mb={2}>
            {deadline && (
              <Box display="flex" alignItems="center" gridGap={6}>
                <FiClock size={14} color="#dc2626" />
                <Typography className={classes.deadlineText}>
                  Cierre: <span style={{ fontWeight: 700 }}>{formatDate(deadline)}</span>
                </Typography>
              </Box>
            )}
          </Box>

          <Status estado={props.estado} />
        </Card.Body>
      </Card>
    </CardActionArea>
  );
};

const useStyles = makeStyles((theme) => ({
  container: {
    borderRadius: "24px",
    margin: "12px",
    transition: "transform 0.2s ease",
    "&:hover": {
      transform: "translateY(-4px)",
    },
    [theme.breakpoints.down(700)]: {
      margin: "0 0 12px 0",
    },
  },
  bootstrapCard: {
    borderRadius: "24px",
    border: "none",
    boxShadow: "0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)",
    overflow: "hidden",
  },
  cardBody: {
    padding: "24px",
    display: "flex",
    flexDirection: "column",
  },
  headerRow: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: "12px",
  },
  tag: {
    padding: "4px 12px",
    borderRadius: "20px",
    fontSize: "11px",
    fontWeight: "800",
    textTransform: "uppercase",
    letterSpacing: "0.5px",
  },
  periodLabel: {
    fontSize: "10px",
    fontWeight: "bold",
    color: "#94a3b8",
    textTransform: "uppercase",
  },
  titleText: {
    fontSize: "18px",
    fontWeight: "800",
    color: "#1e293b",
    lineHeight: 1.2,
  },
  teacherText: {
    fontSize: "14px",
    color: "#64748b",
    fontWeight: "500",
  },
  deadlineText: {
    fontSize: "12px",
    color: "#64748b",
  },
  statusBtn: {
    marginTop: "auto",
    padding: "12px",
    borderRadius: "14px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: "8px",
    color: "white",
    transition: "all 0.3s ease",
    boxShadow: "0 4px 6px -1px rgba(0, 0, 0, 0.1)",
    "&:hover": {
      boxShadow: "0 10px 15px -3px rgba(0, 0, 0, 0.2)",
      opacity: 0.9,
    },
  },
}));

export default CardCustom;
